import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { FlightOperationNotificationClient, FlightOperationNotificationDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useSubmitFlightOperationNotification() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<FlightOperationNotificationDTO, ProblemDetails, number>({
    mutationKey: [queryKeys.FlightOperationNotification.Submit],
    mutationFn: (reportId: number) => flightOperationNotificationClient.submit(reportId),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useSubmitFlightOperationNotification;
